module.exports = __webpack_public_path__ + "1792395595471/fonts/Metropolis-Bold.74938f5.woff";